"use client"
import React,{useState} from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import { usePathname } from "next/navigation";


export const menuItems = [
    {
      area: "item1",
      title: "Home",
      desc: "Create and deploy targeted email and SMS campaigns effortlessly.",
      path: "/",
    },
    {
      area: "item3",
      title: "Our Services",
      desc: "Create, schedule, and analyze email and SMS campaigns with ease.",
      path: "/#ourservices",
    },
    {
      area: "item2",
      title: "About Us",
      desc: "Foster collaboration and teamwork among team members with built-in communication and collaboration tools.",
      path: "/about-us",
    },
    {
      area: "item2",
      title: "Get Started",
      desc: "Get Started Now.",
      path: "/welcome",
    },
   
  ];

export default function Navbar() {
    const pathname = usePathname();
    const [clicked, setClicked] = useState(false);
    const [mobileClicked, setMobileClicked] = useState(false);
   
  
  return (
  
      <div className="max-w-[1040px] mx-auto pt-6 px-0 md:px-5 lg:px-5">
        <div className=" hidden md:flex flex-row justify-between items-center">
          <div className="flex flex-row gap-8 items-center">
            <img src="/assets/aswift-logo.svg" />
            <div className="flex flex-row gap-8  items-center text-white">
             
      <Link href="/" className={pathname === "/" ? "sb-ac text-[18px]" : "text-[16px]"}>
        Home
      </Link>
      <Link
       href="/#ourservices"
        // className={pathname === "/services" ? "sb-ac text-[18px]" : "text-[16px]"}
      >
        Our Services
      </Link>
      <Link
        href="/about-us"
        className={pathname === "/about-us" ? "sb-ac text-[18px]" : "text-[16px]"}
      >
        About Us
      </Link>


          </div>
          </div>
          
          <div className="flex flex-row gap-7 items-center">
            <div className="rounded-[8px] bg-black px-5 py-3 text-white">
            <Link href="/#waitlist-section">Join the wait-list</Link>
            </div>
            <div className="rounded-[8px]  bg-primary-tertiary px-5 py-3 text-white max-w-[180px] flex flex-row justify-center items-center">
            <Link
              href="/welcome"
            >
              Get Started
            </Link>
          </div>
          </div>
        </div>


    <div className="flex md:hidden flex-row justify-between items-center p-[1.5rem]">
    <div className="relative w-full">
      <img src="/assets/aswift-logo.svg" />
      {mobileClicked && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          transition={{ duration: 0.5 }}
          className="absolute left-0 top-[4.4375rem] w-full"
        >
          <div className="bg-white w-full px-5 py-[0.75rem] shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.1)_0px_4px_6px_-2px_rgba(16,24,40,0.05)]">
            {menuItems.map((item, idx) => {
              return (
                <div
                  key={idx}
                  className="flex flex-row gap-x-[1.5rem] gap-y-[0.5rem] w-full py-2"
                  onClick={() => {setMobileClicked(false)}}
                >
                    <Link
                    href={item.path}
                    className={pathname === item.path ? "sb-ac text-[18px]" : "text-[16px]"}
                  >
                    {item.title}
                  </Link>
                </div>
              );
            })}
              <div className="flex flex-col gap-3">
            {/* <div className="text-black"><Link href="">Log in</Link></div>
            <div className="rounded-[100px] bg-primary px-5 py-3 text-white w-[100px]">
                <Link href="">Sign up</Link>
            </div> */}
          </div>
          </div>
        </motion.div>
      )}
    </div>
    {mobileClicked ? (
      <div onClick={() => {setMobileClicked(false)}}><img src="/assets/close.svg" className="h-[1.5rem] w-[1.5rem]" /> </div>
    ) : (
      <div onClick={() => {setMobileClicked(true)}}><img src="/assets/menu.svg" className="h-[1.5rem] w-[1.5rem]" /> </div>
    //   <div className="rounded-[8px]  bg-black px-5 py-3 text-[10px] text-white  min-w-[120px] flex flex-row justify-center items-center">
    //   <Link href="/#waitlist-section">Join the wait-list</Link>
    // </div>
    )}
  </div>
      </div>

  );
}
